export enum AnalyticsFlowEnum {
  CLINICAL_REVIEW_ORDER = "clinical-review-order",
  PREAPPROVED_ORDER_DETAILS = "preapproved-order-details",
  CRP = "CRP"
}
